import { createCustomEvent } from "../../../../javascript/shared/helpers";

export default class extends Controller {

  connect() {
    this.resetMaybe = this.resetMaybe.bind(this);
    App.Helpers.listenToCustomEvent(document, "list:reset-edit-all", this.resetMaybe);
  }

  toggleAllForms(event) {
    event && event.preventDefault();
    const eventName = `list:${this.shouldClose ? "close" : "open"}-all-forms`;
    if (this.shouldClose ? confirm(this.confirmMessage) : true) {
      document.dispatchEvent(createCustomEvent(eventName, this.element, { listID: this.milestoneID }));
    }
    this.shouldClose = !this.shouldClose;
  }

  resetMaybe(event) {
    const { listID } = event.detail;
    if (listID == this.milestoneID) {
      this.shouldClose = false;
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get shouldClose() {
    return ["1", 1, "true", true].includes(this.data.get("should-close"));
  }

  set shouldClose(val) {
    this.data.set("should-close", val ? "1" : null);
    this.element.innerText = `${val ? "Close" : "Open"} All Edit Forms`;
  }

  get milestoneID() {
    return this.data.get("milestone-id");
  }

  get confirmMessage() {
    return "Warning: if you continue, your changes will NOT be saved! Are you sure?"
  }
};



// WEBPACK FOOTER //
// ./app/components/milestones/assets/javascript/milestones-edit-all-button-controller.js